import React from 'react';
import { FadeIn } from './FadeIn';
export function StatsAndTestimonials() {
  return <section className="py-8 bg-surface border-y border-white/5" data-id="element-429">
      <div className="container mx-auto px-4" data-id="element-430">
        <FadeIn data-id="element-431">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4 divide-x-0 md:divide-x divide-white/10 mb-8" data-id="element-432">
            <div className="flex flex-col items-center text-center px-4" data-id="element-433">
              <span className="text-3xl mb-3" aria-hidden="true" data-id="element-434">
                🏭
              </span>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-435">
                +70
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-436">
                Talleres confían
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-437">
              <span className="text-3xl mb-3" aria-hidden="true" data-id="element-438">
                📚
              </span>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-439">
                6
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-440">
                Tomos listos
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-441">
              <span className="text-3xl mb-3" aria-hidden="true" data-id="element-442">
                🎁
              </span>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-443">
                4
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-444">
                Bonos incluidos
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-445">
              <div className="flex gap-1 mb-3" data-id="element-446">
                {[...Array(5)].map((_, i) => <span key={i} className="text-yellow text-lg" data-id="element-447">
                    ★
                  </span>)}
              </div>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-448">
                4.9/5
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-449">
                Calificación
              </span>
            </div>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-450">
          <FadeIn delay={0.1} data-id="element-451">
            <div className="bg-background p-6 rounded-2xl border border-white/5 h-full flex flex-col" data-id="element-452">
              <div className="flex gap-1 mb-4" data-id="element-453">
                {[...Array(5)].map((_, i) => <span key={i} className="text-yellow text-sm" data-id="element-454">
                    ★
                  </span>)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-455">
                "Armé el primer trabajo con el sistema y no tuve que medir dos
                veces. Las tablas de descuento me cambiaron la vida."
              </p>
              <div className="flex items-center gap-3" data-id="element-456">
                <div className="w-10 h-10 rounded-full bg-surfaceLight flex items-center justify-center font-bold text-gold" data-id="element-457">
                  J
                </div>
                <div data-id="element-458">
                  <p className="font-bold text-white text-sm" data-id="element-459">Jorge R.</p>
                  <p className="text-xs text-gray-500" data-id="element-460">Córdoba</p>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-461">
            <div className="bg-background p-6 rounded-2xl border border-white/5 h-full flex flex-col" data-id="element-462">
              <div className="flex gap-1 mb-4" data-id="element-463">
                {[...Array(5)].map((_, i) => <span key={i} className="text-yellow text-sm" data-id="element-464">
                    ★
                  </span>)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-465">
                "Le di los planos a mi ayudante y fabricó solo. Por primera vez
                no tuve que estar encima de todo."
              </p>
              <div className="flex items-center gap-3" data-id="element-466">
                <div className="w-10 h-10 rounded-full bg-surfaceLight flex items-center justify-center font-bold text-gold" data-id="element-467">
                  M
                </div>
                <div data-id="element-468">
                  <p className="font-bold text-white text-sm" data-id="element-469">Marcelo P.</p>
                  <p className="text-xs text-gray-500" data-id="element-470">
                    Rosario · Taller de Aluminio
                  </p>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-471">
            <div className="bg-background p-6 rounded-2xl border border-white/5 h-full flex flex-col" data-id="element-472">
              <div className="flex gap-1 mb-4" data-id="element-473">
                {[...Array(5)].map((_, i) => <span key={i} className="text-yellow text-sm" data-id="element-474">
                    ★
                  </span>)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-475">
                "El Tomo 6 de presupuestos me hizo darme cuenta que estaba
                trabajando sin ganancia real. Ahora cobro lo que corresponde."
              </p>
              <div className="flex items-center gap-3" data-id="element-476">
                <div className="w-10 h-10 rounded-full bg-surfaceLight flex items-center justify-center font-bold text-gold" data-id="element-477">
                  C
                </div>
                <div data-id="element-478">
                  <p className="font-bold text-white text-sm" data-id="element-479">Carlos A.</p>
                  <p className="text-xs text-gray-500" data-id="element-480">Buenos Aires</p>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}